import React from 'react';
import PropTypes from 'prop-types';
import CreditCardInfoCard from './CreditCardInfoCard';
import WalletInfoCard from './WalletInfoCard';

export default function PaymentMethodInfoCard({ method, primary }) {
  return (
    <>
      {method.card.wallet ? (
        <WalletInfoCard wallet={method.card.wallet} primary={primary} />
      ) : (
        <CreditCardInfoCard card={method.card} primary={primary} />
      )}
    </>
  );
}

PaymentMethodInfoCard.propTypes = {
  method: PropTypes.object.isRequired,
  primary: PropTypes.bool,
};
